import { __extends } from "tslib";
import * as React from 'react';
import { PreviewMode } from '../preview-elements/preview-context';
import { TextButton } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
var TeaserPreviewWrapper = /** @class */ (function (_super) {
    __extends(TeaserPreviewWrapper, _super);
    function TeaserPreviewWrapper(props) {
        return _super.call(this, props) || this;
    }
    TeaserPreviewWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(PreviewMode.Consumer, null, function (value) {
            return value.isPreview && !_this.props.teaser ? (React.createElement(TextButton, { weight: "normal", size: "medium", dataHook: "solution-info-teaser", as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info", target: "_blank" },
                React.createElement(TranslatedKey, { tkey: 'solution.page.preview.teaserCTA' }))) : (_this.props.children);
        }));
    };
    return TeaserPreviewWrapper;
}(React.Component));
export { TeaserPreviewWrapper };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
//# sourceMappingURL=teaser-wrapper.js.map